// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

// Components Imports
import RevvLogo from "../RecipientDocHeader/RevvLogo";
import RecipientDocTitle from "../RecipientDocHeader/RecipientDocTitle";
import RevvEsignHeaderButtons from "./RevvEsignHeaderButtons";
import EsignDocInfoPopup from "./EsignDocInfoPopup";

class RevvEsign extends Component {
  state = { showHeaderShadow: false };

  componentDidMount() {
    document.addEventListener("scroll", this._headerCSSWhenScroll, true);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this._headerCSSWhenScroll, true);
  }

  _headerCSSWhenScroll = event => {
    if (event && event.target && event.target.scrollTop > 55) {
      if (!this.state.showHeaderShadow) {
        this.setState({ showHeaderShadow: true });
      }
    } else if (this.state.showHeaderShadow) {
      this.setState({ showHeaderShadow: false });
    }
  };

  render() {
    return (
      <Fragment>
        {/* ----------- Shared document "recipient" and "sender" info popup ----------- */}
        {/* -------- removed below welcome popup -------*/}
        {!this.props.isSigned && false && (
          <EsignDocInfoPopup
            sharingHash={this.props.signingHash}
            docID={this.props.docID}
          />
        )}

        <div
          className={`recipientdocheader-container ${
            this.state.showHeaderShadow ? "header-shadow" : ""
          } ${this.props.isRevvToolbarActive ? "active-revvtoolbar" : ""}`}>
          {/* ----------- Revv Logo and Document title section ----------- */}
          <div className="recipientdocheader-left-section">
            <RevvLogo
              linkUrl={`${process.env.REACT_APP_DOMAIN_NAME}?utm_source=sharedlink`}
              documentPageType={this.props.documentPageType}
              sharingHash={this.props.signingHash}
            />
            <RecipientDocTitle documentTitle={this.props.doc_name} />
          </div>
          {/* ----------- Notes, Attachments, Download and other action buttons section ----------- */}
          <div className="recipientdocheader-right-section">
            <RevvEsignHeaderButtons
              data-test="recipientdocheaderbuttons"
              isSharedDocument={this.props.isSharedDocument}
              docID={this.props.docID}
              sharingHash={this.props.signingHash}
              documentPageType="ESIGN_DOCUMENT"
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const {
    document: { showForm },
    clickedActiveComponentId,
    activeComponentMeta: { componentId },
  } = state.DocumentStore;
  const { doc_name, isSigned } = state.RevvSignStore;
  let isRevvToolbarActive = false;
  if (
    props.isSharedDocument &&
    showForm &&
    componentId === clickedActiveComponentId
  ) {
    isRevvToolbarActive = true;
  }
  return { isRevvToolbarActive, doc_name, isSigned };
};

export default connect(mapStateToProps, null)(RevvEsign);
